import React from "react";
import { Link } from "./Link";
import { cn } from "@repo/utils/cn";

export interface BreadcrumbItem {
  title: string;
  url?: string;
  noFollow?: boolean;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

/**
 * Breadcrumbs component for navigation
 * Displays a trail of links separated by "/"
 */
export function Breadcrumbs({ items, className = "" }: BreadcrumbsProps) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn("uipm:flex uipm:items-center", className)}
    >
      <ol className="uipm:flex uipm:items-center uipm:gap-[8px] uipm:list-none uipm:p-0 uipm:m-0 uipm:flex-wrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li
              key={`${item.url || item.title}-${index}`}
              className="uipm:flex uipm:items-center uipm:gap-[8px]"
            >
              {isLast ? (
                <span
                  className="uipm:text-[var(--typography-sizes-body-medium,16px)] uipm:leading-[var(--typography-line-heights-body-medium,26px)] uipm:font-medium uipm:!text-[var(--typography-colors-text-heading)]"
                  aria-current="page"
                >
                  {item.title}
                </span>
              ) : (
                <>
                  {item.url ? (
                    <Link
                      href={item.url}
                      noFollow={item.noFollow}
                      className="uipm:text-[var(--typography-sizes-body-medium,16px)] uipm:leading-[var(--typography-line-heights-body-medium,26px)] uipm:font-medium uipm:!text-[var(--typography-colors-text-faded)] uipm:hover:underline uipm:no-underline"
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <span className="uipm:text-[var(--typography-sizes-body-medium,16px)] uipm:leading-[var(--typography-line-heights-body-medium,26px)] uipm:font-medium uipm:!text-[var(--typography-colors-text-faded)]">
                      {item.title}
                    </span>
                  )}
                  <span
                    className="uipm:text-[var(--typography-sizes-body-medium,16px)] uipm:leading-[var(--typography-line-heights-body-medium,26px)] uipm:!text-[var(--typography-colors-text-faded)]"
                    aria-hidden="true"
                  >
                    /
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
